<ng-container>
  <app-setting-item [title]="title()" [subtitle]="tooltip()" [control]="control()">
    <ng-template #view>
      @for(opt of selectedValues(); track opt) {
        <app-tag-badge>{{opt}}</app-tag-badge>
      } @empty {
        {{null | defaultValue}}
      }
    </ng-template>

    <ng-template #edit>
      <textarea rows="3" class="form-control"
                [appFormField]="control()"
                [value]="textFieldValue()"
                (change)="onTextFieldChange($event)" [disabled]="disabled()">
      </textarea>
    </ng-template>

  </app-setting-item>
</ng-container>
